/**
 * @module
 */

let uuid = 0

function createUUID(prefix = ''): string {
    return `${prefix}${uuid++}`
}

export { createUUID }
